import { heroImage, stats } from "@/mocks/doujin";

export default function Hero() {
  const scrollTo = (href: string) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="relative flex h-[560px] w-full items-center justify-center md:h-[680px]">
        <img
          src={heroImage}
          alt="同人动漫二次元同人作品创作场景插画"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60" />

        <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
            <i className="ri-sparkling-2-line text-primary-300" />
            漫画本 · 插画集 · 四格漫 · 条漫 · 短篇集 · 画集打包
          </span>

          <h1 className="font-heading mt-6 text-3xl leading-snug text-background-50 md:text-5xl md:leading-snug">
            收藏每一份热爱
            <br className="md:hidden" />
            <span className="text-primary-300">的二次元作品</span>
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            同人动漫汇聚漫画本、插画集、四格漫、条漫、短篇集与画集打包等多种形式的同人佳作，
            分类清晰、浏览方便，满足不同阅读偏好，一起发现更多好作品。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={() => scrollTo("#categories")}
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览作品分类
            </button>
            <button
              onClick={() => scrollTo("#works")}
              className="cursor-pointer whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
            >
              看热门推荐
            </button>
          </div>
        </div>
      </div>

      <div className="relative z-10 -mt-14 mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-200 bg-background-200 sm:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center justify-center gap-1 bg-background-50 px-4 py-6"
            >
              <span className="font-heading text-2xl text-primary-600 md:text-3xl">
                {s.value}
              </span>
              <span className="text-xs text-foreground-600 md:text-sm">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}